<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M-0.93,782.5v5.71l-3.57,4.29l3.57,4.29v5.71l-8.57-10L-0.93,782.5z M0.1,790.18v-7.68h0.8v7.68l1.74,2.32l-1.74,2.32v7.68
	H0.1v-7.68l-1.74-2.32L0.1,790.18z M1.93,796.79l3.57-4.29l-3.57-4.29v-5.71l8.57,10l-8.57,10V796.79z"/>
</svg>

</template>